import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { LoggerService } from '@timechef/core/logging';

@Directive({
  selector: '[focusOnDisplay]',
  standalone: false,
})
export class FocusDirective implements OnInit {
  @Input() focusOnDisplay?: boolean = false;

  constructor(
    loggerService: LoggerService,
    private el: ElementRef,
  ) {
    if (!this.el.nativeElement['setFocus']) {
      loggerService.getLogger('FocusDirective').error('Element does not have setFocus method.', { el });
    }
  }

  ngOnInit(): void {
    if (this.focusOnDisplay && this.el.nativeElement['setFocus']) {
      setTimeout(() => {
        this.el.nativeElement.setFocus();
      }, 150);
    }
  }
}
